import { memo } from 'react';

import GoalPosition from '../GoalPosition';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const EnhancedStatisticsModule = ({ data }) => {
  const t = useTranslateFn();

  return (
    <div className={styles.tsPosition}>
      <div className={styles.tsPositionTitle}>{t('position')}</div>
      <div className={styles.tsPositionPosition}>
        <GoalPosition data={data?.goalCoordinates} />
        <div className={styles.tsPositionStats}>
          <div>
            <div className={styles['ts-position__stats--stat']}>{data?.matchesData?.matches_appearance}</div>
            <div className={styles['ts-position__stats--label']}>
              {t(`${data?.matchesData?.matches_appearance > 1 ? 'stats_MatchesPlayed' : 'nav_match'}`)}
            </div>
          </div>
          <div>
            <div className={styles['ts-position__stats--stat']}>{data?.avgGoalData?.goals?.player}</div>
            <div className={styles['ts-position__stats--label']}>{t('stats_avg_goal_per_match')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(EnhancedStatisticsModule);
